import {
  ArrayParam,
  BooleanParam,
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params"
import { get } from "lodash"

const config = {
  q: StringParam,
  country: withDefault(ArrayParam, [], false),
  style: withDefault(ArrayParam, [], false),
  region: withDefault(ArrayParam, [], false),
  distillery: withDefault(ArrayParam, [], false),
  abvmin: NumberParam,
  abvmax: NumberParam,
  costmin: NumberParam,
  costmax: NumberParam,
  volumemin: NumberParam,
  volumemax: NumberParam,
  isonsale: BooleanParam,
  orderby: StringParam,
}

export enum SearchOrder {
  TITLE = "name",
  SIMILARITY = "similarity",
  POPULARITY = "popularity",
  DISCOUNT = "discount",
  RATING = "rating",
}

export type SearchQueryParameter = keyof typeof config
export type SearchQueryType = {
  q?: string
  country?: string[]
  style?: string[]
  region?: string[]
  distillery?: string[]
  abvmin?: number
  abvmax?: number
  costmin?: number
  costmax?: number
  volumemin?: number
  volumemax?: number
  isonsale?: boolean
  orderby?: SearchOrder
}

export const useSearchParameters = () => {
  const [query, setQuery] = useQueryParams(config)

  const toggleQueryParam = (
    type: SearchQueryParameter,
    value: string | number | boolean | undefined
  ) => {
    const existingParam = get(query, type)
    if (Array.isArray(existingParam) && typeof value === "string") {
      const exitingFilters = new Set<string | number>(
        existingParam as (string | number)[]
      )

      if (exitingFilters.has(value)) exitingFilters.delete(value)
      else exitingFilters.add(value)

      setQuery({ [type]: [...exitingFilters] })
    } else {
      setQuery({ [type]: value })
    }
  }

  return [query as SearchQueryType, toggleQueryParam] as const
}
